module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.7118957e.ttf";